import { IAddressDetail, IServiceQualificationResponse } from '../api/sq';

export enum SQStep {
  INVALID = 'error',
  ADDRESS_LOOKUP = 'search',
  SELECT_ENTITY = 'select-entity',
  SERVICEABILITY_DETAILS = 'serviceability-details',
  OFFERS = 'offers'
}

export interface ISQFlow {
  step: SQStep;
  isComplete: boolean;
  initialManualInput: boolean;
  showCheckAnotherAddressButton: boolean;
  sqLastDoneAt?: number;
  selectedAddress?: IAddressDetail;
  serviceabilityDetails?: IServiceQualificationResponse;
  structuredAddressResultCount: number;
  sameAddressError: boolean;
}
